export var STORE_NAME = 'core/blocks';
//# sourceMappingURL=constants.js.map